import { createRouter, createWebHistory } from 'vue-router'
import EventListView from '../views/EventListView.vue'
import EventLayout from '../views/event/EventLayout.vue'
import EventDetails from '../views/event/EventDetailsView.vue'
import EventRegister from '../views/event/EventRegisterView.vue'
import EventEdit from '../views/event/EventEditView.vue'
import EventCreate from '../views/event/EventCreateView.vue'
import NotFound from '../views/NotFoundView.vue'
import NetworkError from '../views/NetworkErrorView.vue'
import nprogress from 'nprogress'
import GlobalStore from '../store/globalStore'
import ErrorDisplay from '@/views/ErrorDisplay.vue'
import Login from '@/views/LoginView.vue'
import EventCapacity from '@/views/event/EventCapacity.vue'
import RegisterUser from '@/views/RegisterUser.vue'
import HomeView from '@/views/HomeView.vue'
import { RouteLocationNormalized } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register-user',
    name: 'RegisterUser',
    component: RegisterUser,
  },
  {
    path: '/about-us',
    name: 'about',
    // alias: '/about-me', //this is bad for SEO
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the roddddute is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/about',
    redirect: { name: 'about' },
  },
  {
    path: '/events',
    name: 'EventList',
    component: EventListView,
    props: (route: RouteLocationNormalized) => ({
      page: parseInt(route.query.page as string) || 1,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: '/events/create',
    name: 'EventCreate',
    component: EventCreate,
    meta: { requiresAuth: true },
  },
  {
    path: '/events/capacity',
    name: 'EventCapacity',
    component: EventCapacity,
    meta: { requiresAuth: true },
  },
  {
    path: '/events/:id',
    name: 'EventLayout',
    props: true,
    component: EventLayout,
    children: [
      {
        path: '',
        name: 'EventDetails',
        component: EventDetails,
        meta: { requiresAuth: true },
      },
      {
        path: 'register',
        name: 'EventRegister',
        component: EventRegister,
        meta: { requiresAuth: true },
      },
      {
        path: 'edit',
        name: 'EventEdit',
        component: EventEdit,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/event/:afterEvent(.*)',
    redirect: (to: RouteLocationNormalized) => {
      return { path: '/events/' + to.params.afterEvent }
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/404/:resource',
    name: '404Resource',
    component: NotFound,
    props: true,
  },
  {
    path: '/network-error/:error',
    name: 'NetworkError',
    component: NetworkError,
    props: true,
  },
  {
    path: '/error/:error',
    name: 'ErrorDisplay',
    props: true,
    component: ErrorDisplay,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

router.beforeEach((to, from) => {
  nprogress.start()

  const loggedIn = !!localStorage.getItem('user')

  if (to.meta.requiresAuth && !loggedIn) {
    GlobalStore.flashMessage = 'Sorry, you are not authorized to view this page'
    setTimeout(() => {
      GlobalStore.flashMessage = ''
    }, 3000)

    if (from.path) {
      return false
    } else {
      return { path: '/' }
    }
  }
})

router.afterEach(() => {
  nprogress.done()
})

export default router
